<template>
  <div id="v-admin-panel-dashboard">
    <div class="v-admin-panel-dash">
      <div class="v-admin-panel-dash-element">
        <div class="v-admin-panel-dash-title">
          <h1>{{collective.images ? Object.keys(collective.images).length : 0}}</h1>
          <span>images</span>
        </div>
        <button @click="goTo('./images')">VIEW IMAGES <i class="material-icons">chevron_right</i></button>
      </div>
      <div class="v-admin-panel-dash-element">
        <div class="v-admin-panel-dash-title">
          <h1>{{collective.members ? Object.keys(collective.members).length : 0}}</h1>
          <span>members</span>
        </div>
        <button @click="goTo('./members')">VIEW MEMBERS <i class="material-icons">chevron_right</i></button>
      </div>
    </div>
    <div class="v-admin-panel-copypaste">
      Your public presence is located at <input class="copypaste" readonly="readonly" :value="'prism.encadyma.com/@/' + collective.handle"/>
    </div>
    <div class="v-tip-friendly">
      <img class="tip-icon" src="../../../assets/Prisima-Happy.png" />
      <div class="tip-content">
        <b>Hello!</b>
        <span>
          This is your Prism dashboard. Above me are some common options for starting out.
          If you can't find what you need above, the sidebar to the left can also help you out.
        </span>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.v-admin-panel-dash {
  width: 800px;
  margin-top: 40px;
  display: flex;

  .v-admin-panel-dash-element {
    width: 32%;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 24px 18px;
    position: relative;
    margin: 6px;

    .v-admin-panel-dash-title {
      h1 {
        font-size: 48px;
        padding: 0;
        margin: 0;
      }
    }

    button {
      display: inline-block;
      font-size: 14px;
      width: auto;
      position: absolute;
      right: 12px;
      bottom: 16px;

      i {
        font-size: 18px;
        vertical-align: middle;
      }
      &:after {display: none;}
    }
  }
}
.v-admin-panel-copypaste {
  font-size: 14px;
  padding: 16px 8px;
  color: #666;
  position: relative;

  input.copypaste {
    font-family: 'Work Sans', sans-serif;
    font-weight: 500;
    border: none;
    display: inline;
    color: #111;
    font-size: 14px;
    min-width: 300px;
    padding: 2px 4px;

    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 3px;

    &:hover, &:focus {
      border: 1px solid rgba(0, 0, 0, 0.4);
    }
  }
}
</style>
<script>
export default {
  props: ['collective'],
  methods: {
    goTo: function (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/General/AdminDashboard.vue